// Central catalog of data-testids
export const IDS = {
  hero: {
    root: "hero-section",
    ctaConnect: "hero-cta-connect",
    ctaProjects: "hero-cta-projects",
  },
  nav: {
    root: "top-nav",
    linkAbout: "nav-link-about",
    linkProjects: "nav-link-projects",
    linkGithub: "nav-link-github",
    linkTestimonials: "nav-link-testimonials",
    linkConnect: "nav-link-connect",
    ctaConnect: "nav-cta-connect",
  },
  projects: {
    root: "projects-section",
    card: (slug) => `project-card-${slug}`,
    link: (slug) => `project-link-${slug}`,
  },
  github: {
    root: "github-section",
    repos: "github-stat-repos",
    followers: "github-stat-followers",
    stars: "github-stat-stars",
    following: "github-stat-following",
    badge: (name) => `github-badge-${name}`,
    topRepo: (name) => `github-top-repo-${name}`,
  },
  experience: { root: "experience-section" },
  about: { root: "about-section" },
  connect: {
    dialog: "connect-dialog",
    openTrigger: "connect-open-trigger",
    name: "connect-input-name",
    email: "connect-input-email",
    phone: "connect-input-phone",
    company: "connect-input-company",
    message: "connect-input-message",
    channelEmail: "connect-channel-email",
    channelWhatsapp: "connect-channel-whatsapp",
    submit: "connect-submit",
    success: "connect-success",
  },
  footer: {
    root: "footer",
    email: "footer-email",
    whatsapp: "footer-whatsapp",
    github: "footer-github",
  },
};
